import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import TableCell from "@mui/material/TableCell";
import { useLocation } from "react-router-dom";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import useCustomTheme from "expert-web-app/src/utils/hooks/useCustomTheme";
export const ActionHeaderCell = ({
  label,
  align,
  verticalAlign
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const theme = useCustomTheme();
  const location = useLocation();
  const isOnboardingDetail = location.pathname === "/onboarding/detail";
  const customStyles = isOnboardingDetail ? {
    backgroundColor: theme.palette.background.elevation1,
    color: theme.palette.text.primary
  } : {};
  const style = isOnboardingDetail ? {
    textAlign: align,
    ...customStyles
  } // Don't include verticalAlign if true
  : {
    textAlign: align,
    verticalAlign,
    ...customStyles
  };
  return /*#__PURE__*/React.createElement(TableCell, {
    style: style,
    classes: {
      root: classes.actionsHeader
    }
  }, t(label));
};
const useStyles = makeStyles({
  actionsHeader: {
    top: 0,
    right: 0,
    zIndex: 102,
    position: "sticky",
    backgroundColor: "#fff",
    width: 100,
    // verticalAlign: "top",
    padding: "8px 16px"
  }
});
export default ActionHeaderCell;
ActionHeaderCell.propTypes = {
  label: PropTypes.string,
  align: PropTypes.string,
  verticalAlign: PropTypes.string
};
ActionHeaderCell.defaultProps = {
  label: "Actions",
  align: "left",
  verticalAlign: "top"
};